import {
    Button,
    Loader,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Notification,
    NotificationBody,
    NotificationHeader,
    ProgressBar,
} from "@adeccoux/tag-ds";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { getNumberOfQuestionAnswered, getTimerValue } from "./resources";

export const buildDeviceNames = (deviceType, deviceList) => {
    let buildText = [];
    if (deviceType === 4) buildText.push(deviceList?.smartphoneLabel);

    if (deviceType === 4 || deviceType === 2)
        buildText.push(deviceList?.tabletLabel);
    if (
        deviceType === 4 ||
        deviceType === 2 ||
        deviceType === 1 ||
        deviceType === 0
    )
        buildText.push(deviceList?.desktopLabel);

    return buildText.join(", ");
};

export const Notifs = ({ type, header, body, icon, close = false }) => {
    const [visible, setVisible] = useState(true);

    const handleClose = () => {
        //setVisible(false);
    };

    return (
        <>
            {visible && (
                <Notification
                    className="docs position_relative "
                    style={{ maxWidth: "100%", top: "0", zIndex: 0 }}
                    data-testid="notification"
                    icon={<span className="material-icons">{icon}</span>}
                    onClose={close ? handleClose : ""}
                    info={type === "info"}
                    success={type === "success"}
                    error={type === "error"}
                    show={visible}
                >
                    <NotificationHeader style={{ lineHeight: "25px" }}>
                        {header}
                    </NotificationHeader>
                    <NotificationBody>{body}</NotificationBody>
                </Notification>
            )}
        </>
    );
};

export const buildReportData = (cand, test) => {
    const newArr = [];
    const result = cand.filter(c =>
        test.some(
            t =>
                c.testId === t.id &&
                newArr.push({
                    instrumentTypeName: t.instrumentTypeName,
                    status: t.status,
                    timeLimit: t.timeLimit,
                    timedByTopic: t.timedByTopic,
                    timeByQuestion: t.timeByQuestion,
                    deviceType: t.deviceType,
                    ...c,
                })
        )
    );
    return newArr;
};

export const CommonPopup = ({
    popupData,
    closeAction,
    approveAction = false,
    setterFun,
}) => {
    const { isOpen, popupHeader, popupBody, popupFooter } = popupData;

    return (
        <>
            {isOpen && (
                <div
                    onClick={() =>
                        setterFun(prev => {
                            prev = { ...prev, isOpen: false };
                            return prev;
                        })
                    }
                >
                    <Modal
                        className="width-80"
                        open={isOpen}
                        onClose={closeAction}
                        renderAsPortal
                        onClick={e => {
                            e.stopPropagation();
                        }}
                    >
                        <ModalHeader>
                            <h4>{popupHeader}</h4>
                        </ModalHeader>
                        <ModalBody>{popupBody}</ModalBody>
                        <ModalFooter className="flex_row">
                            <Button
                                className="mr2 b2 width_auto full-width_mobile text_uppercase"
                                onClick={
                                    approveAction ? approveAction : closeAction
                                }
                            >
                                {popupFooter}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )}
        </>
    );
};

export const AssessmentFoundPopup = ({
    popupData,
    closeAction,
    reuseAction,
    launchAction,
    setterFun,
    phrases,
}) => {
    const { isOpen, popupHeader, popupBody } = popupData;

    return (
        <>
            {isOpen && (
                <div
                    onClick={() =>
                        setterFun(prev => {
                            prev = { ...prev, isOpen: false };
                            return prev;
                        })
                    }
                >
                    <Modal
                        className="width-80"
                        open={isOpen}
                        onClose={closeAction}
                        renderAsPortal
                        onClick={e => {
                            e.stopPropagation();
                        }}
                    >
                        <ModalHeader>
                            <h4>{popupHeader}</h4>
                        </ModalHeader>
                        <ModalBody>
                            {popupBody.split("\n").map(str => (
                                <div>{str}</div>
                            ))}
                        </ModalBody>
                        <ModalFooter
                            className="flex_row flex_col_mobile justify-content_between"
                        >
                            <Button
                                className="mr2 b2 width_auto full-width_mobile text_uppercase"
                                onClick={() =>
                                    launchAction(popupData.test, popupData.user)
                                }
                            >
                                {phrases?.["26000105"]}
                            </Button>
                            <Button
                                className="mr2 b2 width_auto full-width_mobile text_uppercase"
                                onClick={() =>
                                    reuseAction(popupData.test, popupData.user)
                                }
                            >
                                {phrases?.["26000106"]}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )}
        </>
    );
};

export const SessionExpireCommonPopup = ({
    sessionStatus,
    sessionApproveAction = false,
}) => {
    const location = useLocation();
    const phrases = location.state.user.siteConfig.phrases;

    return (
        <Modal
            className="width-80 full-width"
            open={sessionStatus}
            renderAsPortal
            onClick={e => {
                e.stopPropagation();
            }}
        >
            <ModalHeader>
                <h4>{phrases?.["56"]}</h4>
            </ModalHeader>
            <ModalBody className="text-02">{phrases?.["15142"]}</ModalBody>
            <ModalFooter className="flex_row">
                <Button
                    className="mr2 b2 full-width_mobile"
                    onClick={sessionApproveAction}
                >
                    {phrases?.["10928"]}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export const CommonLoader = () => {
    return (
        <Loader
            className="align-items_start justify-content_center pt5 full-screen"
            spinner
            title="Hold on a sec..."
        />
    );
};

export const QuesLoader = ({ show }) => {
    return (
        <div className="trans-loader-container">
            {show && (
                <Loader
                    className="align-items_start justify-content_center custom-loader"
                    spinner
                />
            )}
        </div>
    );
};

export const useTimer = () => {
    const [currentTime, setCurrentTime] = useState(-1);
    const counterTimerRef = useRef();
    const startTimeRef = useRef(0);
    const topicStartTimeRef = useRef(0);
    const timerStartTimestampRef = useRef(null);
    const initialTimeRef = useRef(0);
    const currentTimeRef = useRef(-1);

    // Keep ref in sync with state
    useEffect(() => {
        currentTimeRef.current = currentTime;
    }, [currentTime]);

    const handleTimer = () => {
        if (!timerStartTimestampRef.current || initialTimeRef.current === 0) return;

        // Always calculate time based on actual elapsed time (works even when tab is hidden)
        const now = Date.now();
        const elapsed = Math.floor((now - timerStartTimestampRef.current) / 1000);
        const remaining = initialTimeRef.current - elapsed;

        if (remaining <= 0) {
            setCurrentTime(0);
            stopTimer();
        } else {
            setCurrentTime(remaining);
        }
    };

    const setTimer = (val) => {
        setCurrentTime(val);
        if (val !== -1 && timerStartTimestampRef.current) {
            initialTimeRef.current = val;
            timerStartTimestampRef.current = Date.now();
        }
    };

    const startTimer = (val = currentTime, type = "assessment") => {
        clearInterval(counterTimerRef.current);

        if (val === -1) {
            setCurrentTime(-1);
            timerStartTimestampRef.current = null;
            return;
        }

        setCurrentTime(val);
        initialTimeRef.current = val;
        timerStartTimestampRef.current = Date.now();

        if (startTimeRef.current === 0 || type === "timeByQuestion") {
            startTimeRef.current = val;
        }
        if (type === "timedByTopic") {
            topicStartTimeRef.current = val;
        }

        counterTimerRef.current = setInterval(handleTimer, 1000);
    };

    const getElapsedTime = () => {
        if (currentTime === -1) return -1;
        return topicStartTimeRef.current
            ? topicStartTimeRef.current - currentTime
            : startTimeRef.current - currentTime;
    };

    const stopTimer = () => {
        clearInterval(counterTimerRef.current);
        timerStartTimestampRef.current = null;
        return topicStartTimeRef.current
            ? topicStartTimeRef.current - currentTime
            : startTimeRef.current - currentTime;
    };

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                if (timerStartTimestampRef.current && currentTimeRef.current !== -1 && counterTimerRef.current) {
                    const now = Date.now();
                    const elapsed = Math.floor((now - timerStartTimestampRef.current) / 1000);
                    const remaining = initialTimeRef.current - elapsed;

                    if (remaining <= 0) {
                        setCurrentTime(0);
                        stopTimer();
                    } else {
                        setCurrentTime(remaining);
                    }
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            clearInterval(counterTimerRef.current);
        };
    }, []);

    return {
        min: currentTime === -1 ? "-1" : String(Math.floor(currentTime / 60)).padStart(2, "0"),
        sec: currentTime === -1 ? "-1" : String(currentTime % 60).padStart(2, "0"),
        totalSecLeft: currentTime,
        setTimer,
        startTimer,
        stopTimer,
        getElapsedTime,
    };
};

export const useTT70Timer = () => {
    const [currentTime, setCurrentTime] = useState(-1);
    const counterTimerRef = useRef();
    const startTimeRef = useRef(0);
    const endTimeRef = useRef(null);
    const topicStartTimeRef = useRef(0);
    
    const handleTimer = () => {
        if (!endTimeRef.current) return;

        const remainingSec = Math.ceil((endTimeRef.current - Date.now()) / 1000);
        if (remainingSec <=0) {
            setCurrentTime(0)
            stopTimer();
            return;
        }

        setCurrentTime(remainingSec);
    };

    const setTimer = val => {
        setCurrentTime(val);
    };

    const startTimer = (val = currentTime, type = "assessment") => {
        clearInterval(counterTimerRef.current);
        setCurrentTime(val); 
        endTimeRef.current = Date.now() + val * 1000;
        handleTimer();
        if (startTimeRef.current === 0 || type === "timeByQuestion") {
            startTimeRef.current = val;
        }
        if (type === "timedByTopic") {
            topicStartTimeRef.current = val;
        }
        counterTimerRef.current = setInterval(handleTimer, 1000);
    };

    const getElapsedTime = () => {
        return topicStartTimeRef.current
            ? topicStartTimeRef.current - currentTime
            : startTimeRef.current - currentTime;
    };

    const stopTimer = () => {
        clearInterval(counterTimerRef.current);
        return topicStartTimeRef.current
            ? topicStartTimeRef.current - currentTime
            : startTimeRef.current - currentTime;
    };

    useEffect(() => {
        return () => clearInterval(counterTimerRef.current);
    }, []);

    return {
        min: String(Math.floor(currentTime / 60)).padStart(2, "0"),
        sec: String(currentTime % 60).padStart(2, "0"),
        totalSecLeft: currentTime,
        setTimer,
        startTimer,
        stopTimer,
        getElapsedTime,
    };
};

export const QuestionCommonPopup = ({ popupData, approveAction = false }) => {
    const { isOpen, popupHeader, popupBody, popupFooter } = popupData;

    return (
        <div>
            <Modal
                className="width-80"
                open={isOpen}
                renderAsPortal
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <ModalHeader>
                    <h4>{popupHeader}</h4>
                </ModalHeader>
                <ModalBody>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: popupBody,
                        }}
                    />
                </ModalBody>
                <ModalFooter className="flex_row">
                    <Button
                        className="mr2 b2 width_auto full-width_mobile text_uppercase"
                        onClick={approveAction ? approveAction : closeAction}
                    >
                        {popupFooter}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export const CommonQuesProgress = ({ test }) => {
    const location = useLocation();
    const phrases = location.state.user.siteConfig.phrases;

    return (
        <ProgressBar
            helper={
                test.startNumber !== test.endNumber
                    ? {
                        left: location.state.warmUp
                            ? test.startNumber +
                            "-" +
                            test.endNumber +
                            "/" +
                            location.state.test.testExample?.at(-1)
                                ?.endNumber +
                            " " +
                            phrases?.["13106"]
                            : test.startNumber +
                            "-" +
                            test.endNumber +
                            "/" +
                            location.state.test.questionsCount +
                            " " +
                            phrases?.["13106"],
                    }
                    : {
                        left: location.state.warmUp
                            ? test.startNumber +
                            "/" +
                            location.state.test.testExample?.at(-1)
                                ?.endNumber +
                            " " +
                            phrases?.["13106"]
                            : test.lastPage && test.startNumber === 1
                                ? test.startNumber +
                                "/" +
                                1 +
                                " " +
                                phrases?.["13106"]
                                : test.startNumber +
                                "/" +
                                location.state.test.questionsCount +
                                " " +
                                phrases?.["13106"],
                    }
            }
            showPercentage={false}
            showSteps
            step={test.endNumber}
            steps={
                location.state.warmUp
                    ? location.state.test.testExample?.at(-1)?.endNumber
                    : test.lastPage && test.startNumber === 1
                        ? 1
                        : location.state.test.questionsCount
            }
            title={phrases?.["14798"]}
            className="flex_gsb sticky bg01"
        />
    );
};

export const TestErrorPopup = ({ closeAction }) => {
    const location = useLocation();
    const phrases = location.state?.user?.siteConfig?.phrases;

    return (
        <div onClick={closeAction}>
            <Modal
                className="width-80"
                open={true}
                onClose={closeAction}
                renderAsPortal
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <ModalHeader>
                    <h4>{location.state?.test?.name}</h4>
                </ModalHeader>
                <ModalBody>{phrases?.["1002195"]}</ModalBody>
                <ModalFooter className="flex_row">
                    <Button
                        className="mr2 b2 width_auto full-width_mobile text_uppercase"
                        onClick={closeAction}
                    >
                        {phrases?.["10928"]}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export const redirectToRC = async () => {
    const redirectUrl = sessionStorage.getItem("redirectUrl");
    if (redirectUrl != undefined && redirectUrl != null && redirectUrl != "") {
        sessionStorage.removeItem("redirectUrl");
        window.location.replace(redirectUrl);
    }
};

export const useScreenTransition = () => {
    const [phase, setPhase] = useState("idle");
    const timers = useRef([]);
    const fadeDuration = 500;
    const loaderThreshold = 500;
    const loading = phase === "fading-out" || phase === "showing-loader";

    const clearTimers = () => {
        timers.current.forEach(clearTimeout);
        timers.current = [];
    };

    const startTransition = (onReadyToSetContent, immediate = false) => {
        clearTimers();
        setPhase("fading-out");

        if (immediate) {
            onReadyToSetContent();
        } else {
            const fadeOutTimer = setTimeout(() => {
                onReadyToSetContent();
            }, fadeDuration);
            timers.current.push(fadeOutTimer);
        }

        const loaderTimer = setTimeout(() => {
            setPhase("showing-loader");
        }, loaderThreshold);

        timers.current.push(loaderTimer);
    };

    const done = () => {
        clearTimers();
        setPhase("fading-in");

        const fadeInTimer = setTimeout(() => {
            setPhase("idle");
        }, fadeDuration);

        timers.current.push(fadeInTimer);
    };

    return {
        phase,
        loading,
        startTransition,
        done,
        cancel: () => {
            clearTimers();
            setPhase("idle");
        },
    };
};

export const redirectToAssessmentSummary = async (
    location,
    navigate,
    testType = 0
) => {
    const res = await getNumberOfQuestionAnswered(
        location?.state?.user?.sessionId,
        location?.state?.test?.id
    );
    navigate("/assessmentSummary", {
        state: {
            totalQuestions:
                testType === 28
                    ? location?.state?.test28Data?.question.length
                    : location?.state?.test?.questionsCount,
            answered: res?.data,
            notAnswered:
                testType === 28
                    ? location?.state?.test28Data?.question.length - res?.data
                    : location?.state?.test?.questionsCount - res?.data,
            phrases: location?.state?.user?.siteConfig?.phrases,
            cobrandingLink: location?.state?.cobrandingLink,
        },
    });
};
export const useTimerValues = () => {
    const [timerValues, setTimerValues] = useState({
        timerOverallAssessment: null,
        timerPerTopic: null,
        timerPerQuestion: null,
    });

    useEffect(() => {
        const loadTimers = async () => {
            try {
                const res = await getTimerValue();

                setTimerValues({
                    timerOverallAssessment: res?.data?.Timer_Overall_Assessment,
                    timerPerTopic: res?.data?.Timer_Per_Topic,
                    timerPerQuestion: res?.data?.Timer_Per_Question,
                });
            } catch (err) {
                console.error(err);
            }
        };

        loadTimers();
    }, []);

    return timerValues;
};
